/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Box } from '@mui/material';
import React, { useState } from 'react';
import EditableCard from 'modules/common/editableCard.component';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { updateExpenseLineItems } from 'modules/expenses/store/expenses.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';

const PrimaryExpenseLineDetailsInfo = props => {
  const { expenseLineItemDetails, enumerations, onUpdateApprovedLineItemDetails, isReadOnly } = props;

  const [isLoading, setIsLoading] = useState(false);
  const accountsPayableTabs = [{ header: 'Accounts Payable', order: 1, iconPath: ['fas', 'suitcase'] }];
  const accountsReceivableTabs = [{ header: 'Accounts Receivable', order: 1, iconPath: ['fas', 'suitcase'] }];
  const basicInfoTabs = [{ header: 'Basic Info', order: 1, iconPath: ['fas', 'suitcase'] }];

  const serviceOptions = enumerations?.services ?? [];
  const payTypeOptions = enumerations?.payTypes ?? [];
  const payrollTypeOptions = enumerations?.payrollTypes ?? [];
  const farCodeOptions = enumerations?.farCodes ?? [];

  const approved = expenseLineItemDetails || {};

  const accountsPayableSummaries = [
    { header: 'Invoice Number', accessorKey: 'apInvoiceNumber', type: 'text', value: approved.apInvoiceNumber ?? '', tab: 1 },
    { header: 'AP Line Desc', accessorKey: 'apLineDescription', type: 'text', value: approved.apLineDescription ?? '', tab: 1 },
    { header: 'AP In Process', accessorKey: 'apInProgress', type: 'date', value: approved.apInProgress ?? null, tab: 1 },
    { header: 'AP Posted', accessorKey: 'apPosted', type: 'date', value: approved.apPosted ?? null, tab: 1 },
    { header: 'Check Number', accessorKey: 'apCheckNumber', type: 'text', value: approved.apCheckNumber ?? '', tab: 1 },
    { header: 'Check Date', accessorKey: 'checkDate', type: 'date', value: approved.checkDate ?? null, tab: 1 },
    { header: 'Wire Transfer', accessorKey: 'wireTransfer', type: 'checkbox', value: approved.wireTransfer ?? false, tab: 1 },
    { header: 'AP Route To', accessorKey: 'apRouteTo', type: 'checkbox', value: approved.apRouteTo ?? false, tab: 1 },
    { header: 'Account One Balance', accessorKey: 'accountOneBalance', type: 'money', value: approved.accountOneBalance ?? null, tab: 1 },
    { header: 'Account Two Balance', accessorKey: 'accountTwoBalance', type: 'money', value: approved.accountTwoBalance ?? null, tab: 1 },
    { header: 'Reduce Advance', accessorKey: 'reduceAdvance', type: 'money', value: approved.reduceAdvance ?? null, tab: 1 }
  ];

  const accountsReceivableSummaries = [
    { header: 'Invoice Number', accessorKey: 'arInvoiceNumber', type: 'text', value: approved.arInvoiceNumber ?? '', tab: 1 },
    { header: 'AR In Progress', accessorKey: 'arInProgress', type: 'date', value: approved.arInProgress ?? null, tab: 1 },
    { header: 'AR Posted', accessorKey: 'arPosted', type: 'date', value: approved.arPosted ?? null, tab: 1 },
    { header: 'AR Amount', accessorKey: 'arAmount', type: 'money', value: approved.arAmount ?? null, tab: 1 },
    { header: 'Cash Received', accessorKey: 'cashReceived', type: 'date', value: approved.cashReceived ?? null, tab: 1 },
    { header: 'AR Paid Date', accessorKey: 'arPaidDate', type: 'date', value: approved.arPaidDate ?? null, tab: 1 },
    { header: 'Check Number', accessorKey: 'arCheckNumber', type: 'text', value: approved.arCheckNumber ?? '', tab: 1 },
    { header: 'AR Paid Amount', accessorKey: 'arPaidAmount', type: 'money', value: approved.arPaidAmount ?? null, tab: 1 },
    { header: 'Writeoff Amount', accessorKey: 'writeOffAmount', type: 'money', value: approved.writeOffAmount ?? null, tab: 1 },
    {
      header: 'Total Deposit Billing',
      accessorKey: 'totalDepositBilling',
      type: 'money',
      value: approved.totalDepositBilling ?? null,
      tab: 1
    },
    { header: 'Balance', accessorKey: 'balance', type: 'text', value: approved.balance ?? '', tab: 1 },
    { header: 'Refund Date', accessorKey: 'refundDate', type: 'date', value: approved.refundDate ?? null, tab: 1 },
    { header: 'Refund Amount', accessorKey: 'refundAmount', type: 'money', value: approved.refundAmount ?? null, tab: 1 },
    { header: 'Refund Check Num', accessorKey: 'refundCheckNum', type: 'text', value: approved.refundCheckNum ?? '', tab: 1 },
    { header: 'Void Invoice Number', accessorKey: 'voidInvoiceNumber', type: 'text', value: approved.voidInvoiceNumber ?? '', tab: 1 },
    { header: 'Void Date', accessorKey: 'voidDate', type: 'date', value: approved.voidDate ?? null, tab: 1 },
    { header: 'Void By (Id)', accessorKey: 'voidById', type: 'text', value: approved.voidById ?? '', tab: 1 },
    { header: 'Unpay Date', accessorKey: 'unpayDate', type: 'date', value: approved.unpayDate ?? null, tab: 1 },
    { header: 'Unpay By (Id)', accessorKey: 'unpayById', type: 'text', value: approved.unpayById ?? '', tab: 1 },
    { header: 'Dep Applied Amount', accessorKey: 'depAppliedAmount', type: 'money', value: approved.depAppliedAmount ?? null, tab: 1 }
  ];

  const basicInfoSummaries = [
    { header: 'Approval Amount', accessorKey: 'approvalAmount', type: 'money', value: approved.approvalAmount ?? null, tab: 1 },
    { header: 'Pay Amount', accessorKey: 'payAmount', type: 'money', value: approved.payAmount ?? null, tab: 1 },
    { header: 'Home Amount', accessorKey: 'homeAmount', type: 'money', value: approved.homeAmount ?? null, tab: 1 },
    { header: 'Host Amount', accessorKey: 'hostAmount', type: 'money', value: approved.hostAmount ?? null, tab: 1 },
    { header: 'USD Amount', accessorKey: 'usdAmount', type: 'money', value: approved.usdAmount ?? null, tab: 1 },
    { header: 'CAD Amount', accessorKey: 'cadAmount', type: 'money', value: approved.cadAmount ?? null, tab: 1 },
    {
      header: 'Budget Currency Amount',
      accessorKey: 'budgetCurrencyAmount',
      type: 'money',
      value: approved.budgetCurrencyAmount ?? null,
      tab: 1
    },
    { header: 'Receipt Amount', accessorKey: 'receiptAmount', type: 'money', value: approved.receiptAmount ?? null, tab: 1 },

    { header: 'Report Date', accessorKey: 'reportDate', type: 'date', value: approved.reportDate ?? null, tab: 1 },
    { header: 'Tax Report Date', accessorKey: 'taxReportDate', type: 'date', value: approved.taxReportDate ?? null, tab: 1 },
    { header: 'Tax Year', accessorKey: 'taxYear', type: 'text', value: approved.taxYear ?? '', tab: 1 },
    { header: 'AP Date', accessorKey: 'apDate', type: 'date', value: approved.apDate ?? null, tab: 1 },

    {
      header: 'Service',
      accessorKey: 'serviceId',
      type: 'dropdown-v2',
      options: serviceOptions,
      value: approved.serviceId ?? ZERO_GUID,
      tab: 1
    },
    {
      header: 'Pay Type',
      accessorKey: 'payTypeId',
      type: 'dropdown-v2',
      options: payTypeOptions,
      value: approved.payTypeId ?? ZERO_GUID,
      tab: 1
    },
    {
      header: 'Payroll Type',
      accessorKey: 'payrollTypeId',
      type: 'dropdown-v2',
      options: payrollTypeOptions,
      value: approved.payrollTypeId ?? ZERO_GUID,
      tab: 1
    },
    {
      header: 'FAR Code',
      accessorKey: 'farCodeId',
      type: 'dropdown-v2',
      options: farCodeOptions,
      value: approved.farCodeId ?? ZERO_GUID,
      tab: 1
    },
    { header: 'Reference', accessorKey: 'reference', type: 'notes', value: approved.reference ?? '', tab: 1 },
    { header: 'Trans Status', accessorKey: 'transStatus', type: 'text', value: approved.transStatus ?? '', tab: 1 },
    { header: 'On Hold Date', accessorKey: 'onHoldDate', type: 'date', value: approved.onHoldDate ?? null, tab: 1 }
  ];

  const updateApprovedExpense = async (tab, values) => {
    setIsLoading(false);
    let request = { ...expenseLineItemDetails, ...values };
    const resp = await onUpdateApprovedLineItemDetails(request);
    if (!resp) {
      props.showToast('Failed to update the approved expense account info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  return (
    <Box>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} xl={8} rowSpacing={2}>
          <EditableCard
            tabs={accountsPayableTabs}
            summaries={accountsPayableSummaries}
            numColumns={5}
            updateFields={updateApprovedExpense}
            isLoading={isLoading}
            hideEdit={isReadOnly}
          />
          <Box sx={{ paddingTop: '16px' }}>
            <EditableCard
              tabs={accountsReceivableTabs}
              summaries={accountsReceivableSummaries}
              numColumns={5}
              updateFields={updateApprovedExpense}
              isLoading={isLoading}
              hideEdit={isReadOnly}
            />
          </Box>
        </Grid>
        <Grid item xs={12} xl={4} rowSpacing={2}>
          <EditableCard
            tabs={basicInfoTabs}
            summaries={basicInfoSummaries}
            numColumns={2}
            updateFields={updateApprovedExpense}
            isLoading={isLoading}
            hideEdit={isReadOnly}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default compose(connect(null, { updateExpenseLine: updateExpenseLineItems }))(PrimaryExpenseLineDetailsInfo);
